import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import Headroom from "react-headroom";
import CheeseburgerMenu from "cheeseburger-menu";
import classNames from "classnames";

export default function nav() {
  const element = document.getElementById("headroom");

  ReactDOM.render(
    <Nav
      headerLogo={element.dataset.headerLogo}
      fadeIn={element.dataset.fadeIn}
      generalEnquiresEmail={element.dataset.generalEnquiresEmail}
      generalEnquiresTelephone={element.dataset.generalEnquiresTelephone}
    />,
    element
  );
}

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);

  if (!ref) {
    return false;
  }

  const observer = new IntersectionObserver(([entry]) =>
    setIntersecting(entry.isIntersecting)
  );

  useEffect(() => {
    observer.observe(ref);
    return () => {
      observer.disconnect();
    };
  }, []);

  return isIntersecting;
}

function Nav({
  headerLogo,
  fadeIn,
  generalEnquiresEmail,
  generalEnquiresTelephone,
}) {
  const [backgroundColor, setBackgroundColor] = useState("offWhite2");
  const [menu, setMenu] = useState(false);
  const headerInView = useOnScreen(
    document.querySelector(".image-header, .video-header, .gallery__slideshow")
  );

  function openMenu() {
    setMenu(true);
  }

  function closeMenu() {
    setMenu(false);
  }

  return (
    <>
      <Menu
        isOpen={menu}
        closeMenu={closeMenu}
        closeCallback={closeMenu}
        generalEnquiresEmail={generalEnquiresEmail}
        generalEnquiresTelephone={generalEnquiresTelephone}
      />
      <Headroom
        onPin={() => setBackgroundColor("white")}
        onUnfix={() => setBackgroundColor("offWhite2")}
      >
        <div
          className={classNames("nav", {
            "nav--transparent": headerInView,
            "nav--fade-in": fadeIn,
          })}
          style={{
            "--navBackground": `var(--${
              headerInView ? "transparent" : backgroundColor
            })`,
          }}
        >
          <div className="nav__button" onClick={openMenu}>
            <div
              className={classNames("nav__line", {
                "nav__line--white": headerInView,
              })}
            ></div>
            <div
              className={classNames("nav__line", {
                "nav__line--white": headerInView,
              })}
            ></div>
            <div
              className={classNames("nav__line", {
                "nav__line--white": headerInView,
              })}
            ></div>
          </div>
          {headerLogo || !headerInView ? (
            <a
              className={classNames("nav__logo", {
                "nav__logo--white": headerInView,
              })}
              href="/"
            ></a>
          ) : null}
        </div>
      </Headroom>
    </>
  );
}

function Menu({
  isOpen,
  closeMenu,
  closeCallback,
  generalEnquiresEmail,
  generalEnquiresTelephone,
}) {
  const navLinks = [
    {
      id: 1,
      title: "Home",
      url: "/",
    },
    {
      id: 2,
      title: "About",
      url: "/about",
    },
    {
      id: 3,
      title: "Services",
      url: "/services",
    },
    {
      id: 4,
      title: "Projects",
      url: "/projects",
    },
    {
      id: 5,
      title: "Journal",
      url: "/journal",
    },
    {
      id: 6,
      title: "Careers",
      url: "/careers",
    },
    {
      id: 7,
      title: "Contact",
      url: "/contact",
    },
  ];

  return (
    <CheeseburgerMenu
      isOpen={isOpen}
      noShadow={true}
      closeCallback={closeCallback}
    >
      <div className="menu">
        <nav className="menu__nav">
          <div className="menu__button" onClick={closeMenu}>
            <div className="menu__line"></div>
            <div className="menu__line"></div>
          </div>
          <ul className="menu__nav-list">
            {navLinks.map((item) => (
              <li key={item.id} className="menu__nav-item">
                <a
                  className="menu__nav-link"
                  href={item.url}
                  target={item.target ? item.target : "_self"}
                >
                  {item.title}
                </a>
              </li>
            ))}
          </ul>
          <div className="caption-title menu__get-in-touch">
            <ul className="menu__secondary-links">
              <li className="menu__secondary-link-item">
                <a
                  className="menu__secondary-link"
                  href="https://www.barrjoinery.co.uk"
                  target="_blank"
                >
                  Barr Joinery
                </a>
              </li>
              <li className="menu__secondary-link-item">
                <a
                  className="menu__secondary-link"
                  href="https://www.barrkitchens.co.uk"
                  target="_blank"
                >
                  Barr Kitchens
                </a>
              </li>
            </ul>
            <h4 className="menu__get-in-touch-title">Get in touch</h4>
            {generalEnquiresEmail || generalEnquiresTelephone ? (
              <ul className="menu__get-in-touch-list">
                {generalEnquiresEmail ? (
                  <li className="menu__get-in-touch-item">
                    <a
                      className="menu__get-in-touch-link"
                      href={`mailto:${generalEnquiresEmail}`}
                    >
                      {generalEnquiresEmail}
                    </a>
                  </li>
                ) : null}

                {generalEnquiresTelephone ? (
                  <li className="menu__get-in-touch-item">
                    <a
                      className="menu__get-in-touch-link"
                      href={`tel:${generalEnquiresTelephone}`}
                    >
                      {generalEnquiresTelephone}
                    </a>
                  </li>
                ) : null}
              </ul>
            ) : null}
          </div>
        </nav>
      </div>
    </CheeseburgerMenu>
  );
}
